import { HTTPService } from './httpService';

const API = new HTTPService();

export const DashboardAPI = {
  /**
   * Fetch dashboard metrics
   * @param {number} installerId - Installer/specialist ID
   * @param {number} days - Lookback period (7, 30, 90, 180 or 365)
   * @param {number|null} dealerId - Optional dealer ID for dealer-specific view
   */
  getMetrics: async (installerId, days = 30, dealerId = null, locationId = null, groupId = null) => {
    const params = { installerId, days };
    if (dealerId) params.dealerId = dealerId;
    if (locationId && locationId !== 'all') params.locationId = locationId;
    // Send groupId whenever we have one — INCLUDING 0, the "Independent" catch-all
    // group (its id is 0 in production). A truthy check silently dropped it, leaving
    // the server unable to scope an Independent-group dashboard. Same fix as
    // navBar.jsx:194. Note this cannot reproduce on dev, where Independent is 2.
    if (groupId != null && groupId !== '') params.groupId = groupId;
    const response = await API.get('/dashboard/metrics', params);
    return response.data;
  }
};
